import React, {forwardRef, useImperativeHandle, useRef} from 'react';

import {ModalOpenerComponent, IModalOpenerComponentRef} from 'components/modal-opener-component';
import {IAisRegisterDocumentDto} from 'store/slices/ais-slice/ais-slice-types';

import {EPudUploadModalMode, usePudUpload} from '../../hooks/use-pud-upload/use-pud-upload';

export interface IPUDModalProps {
    registerDocument: IAisRegisterDocumentDto;
}

export const PUDModal = forwardRef<any, IPUDModalProps>(({
    registerDocument,
}: IPUDModalProps, ref) => {
    const PUDModalRef = useRef<IModalOpenerComponentRef>(null);

    useImperativeHandle(ref, () => PUDModalRef.current);

    const {
        form,
        setArchiveSystem,
        PUDUploadFormJSX,
        isUploadingPUD,
    } = usePudUpload({
        registerDocument,
        PUDModalRef,
        mode: EPudUploadModalMode.inModal,
    });

    return (
        <ModalOpenerComponent
            ref={PUDModalRef}
            controlLabels={{
                cancel: 'Закрыть',
            }}
            handleSave={() => {
                form.submit();
            }}
            disabledControls={{
                save: isUploadingPUD,
            }}
            loadingControls={{
                save: isUploadingPUD,
            }}
            modalProps={{
                title: 'Размещение ПУД',
                width: 600,
                centered: true,
                forceRender: false,
                destroyOnClose: true,
            }}
            afterModalClose={() => {
                setArchiveSystem(undefined);
                form.resetFields();
            }}
        >
            {PUDUploadFormJSX}
        </ModalOpenerComponent>
    );
});
